function getNestedValue(obj, key) {
    return key.split('/').reduce((acc, part) => acc && acc[part], obj);
}

const changeValues = (data, operation) => {

    //Clone the data so it is not affected by the operations
    let dataToChange = { ...data }

    // Loop through each field in the rootFields array
    for (const field of operation.fields) {
        const { targetField, fromValue, toValue, sourceField } = field;
        
        // Handle sourceField - copy value from another field in the source data
        if (sourceField) {
            const sourceValue = data[sourceField];
            // Only set the target field if the source value is a valid non-empty string
            if (typeof sourceValue === 'string' && sourceValue.length > 0 && sourceValue !== 'false') {
                dataToChange[targetField] = sourceValue;
            } else {
                // If source value is not valid, delete the field to avoid validation errors
                delete dataToChange[targetField];
                console.log(`[changeValues] Deleted ${targetField} - sourceField '${sourceField}' has invalid value:`, sourceValue);
            }
            continue;
        }
        
        // Retrieve Nested Values
        if (typeof toValue === 'string' && toValue.includes('/')) {
            dataToChange[targetField] = getNestedValue(data, toValue)
        } else 
        // Retrieve Today's Date
        if (typeof toValue === 'string' && toValue.includes('{today}')) {
            let now = new Date()
            dataToChange[targetField] = now
        } else 
        
        {

            // Check if the target field exists in data and if its value matches fromValue
            if (data[targetField] === fromValue) {
                // If it matches, change the value to toValue
                dataToChange[targetField] = toValue;
            }

            if (!fromValue) {
                //If the toValue is an actual value of the Data passed then use that
                if (data[toValue]) {
                    dataToChange[targetField] = data[toValue]
                    //Otherwise just fill in the value of the thing
                } else {
                    dataToChange[targetField] = toValue
                }

            }

        }

    }
    return dataToChange

}

export default changeValues